// Search → Collection redirect
// Intercepts search form submissions and redirects to collection pages
// when the query matches a collection name.

(function() {
  'use strict';

  // Collection mapping: search term → collection URL
  var COLLECTION_MAP = {
  "dr congo": "/collections/dr-congo",
  "greece": "/collections/greece",
  "home page": "/collections/frontpage",
  "ipswich": "/collections/ipswich",
  "iraq": "/collections/iraq",
  "kb": "/collections/kb",
  "panamá": "/collections/panama",
  "tigres uanl 🟩🔵 🇲🇽": "/collections/tigres-uanl-🔵",
  "tigres uanl 🟩 🇲🇽": "/collections/tigres-uanl-🔵",
  "ac milan": "/collections/ac-milan",
  "africa national teams": "/collections/africa-national-teams-footjersey",
  "ajax": "/collections/ajax",
  "al hilal": "/collections/al-hilal",
  "al ittihad": "/collections/al-ittihad",
  "al nassr": "/collections/al-nassr",
  "albania national football team": "/collections/albania",
  "albania national team collection": "/collections/albania-national-team-collection",
  "algeria": "/collections/algeria",
  "américa": "/collections/america",
  "americas national teams": "/collections/americas-national-teams-footjersey",
  "argentina": "/collections/argentina",
  "arsenal": "/collections/arsenal",
  "as roma": "/collections/as-roma",
  "asia national teams": "/collections/asia-national-teams-footjersey",
  "aston villa": "/collections/aston-villa",
  "athletic bilbao": "/collections/athletic-bilbao",
  "atlas": "/collections/atlas",
  "atlético madrid": "/collections/atletico-madrid",
  "atlético mineiro": "/collections/atletico-mineiro",
  "barcelona": "/collections/barcelona",
  "bayer leverkusen": "/collections/bayer-leverkusen",
  "bayern munich": "/collections/bayern-munich",
  "bayern munich & germany national team collection": "/collections/bayern-munich-germany-national-team-collection",
  "bayern munich + germany 125th anniversary shirt": "/collections/bayern-munich-germany-125th-anniversary-shirt",
  "belgium": "/collections/belgium",
  "benfica": "/collections/benfica",
  "beşiktaş": "/collections/besiktas",
  "best sellers collection": "/collections/best-sellers-collection",
  "blackburn rovers": "/collections/blackburn-rovers",
  "boca juniors": "/collections/boca-juniors-1",
  "borussia dortmund": "/collections/borussia-dortmund",
  "botafogo": "/collections/botafogo",
  "brasileirão": "/collections/brasileirao",
  "brazil": "/collections/brasil",
  "brighton & hove albion": "/collections/brighton-hove-albion",
  "bundesliga": "/collections/bundesliga",
  "burnley": "/collections/burnley-⚪",
  "canada": "/collections/canada",
  "chelsea": "/collections/chelsea",
  "chile": "/collections/chile",
  "chivas": "/collections/chivas",
  "club américa": "/collections/club-america",
  "club león": "/collections/club-leon",
  "clubs from around the world collection": "/collections/clubs-from-around-the-world-collection",
  "collection of legends": "/collections/collection-of-legends",
  "colombia": "/collections/colombia",
  "corinthians": "/collections/corinthians",
  "coventry city": "/collections/coventry-city",
  "croatia": "/collections/croatia",
  "cruzeiro": "/collections/cruzeiro",
  "crystal palace": "/collections/crystal-palace",
  "denmark": "/collections/denmark",
  "derby county": "/collections/derby-county",
  "efl championschip": "/collections/epl-championschip",
  "england": "/collections/england",
  "estoril praia": "/collections/estoril-praia",
  "european national teams": "/collections/europe-national-teams-footjersey",
  "everton": "/collections/everton",
  "fan jerseys world cup 2026 ™": "/collections/fan-jerseys-world-cup-2026-™",
  "fc porto": "/collections/fc-porto",
  "fc st pauli": "/collections/fc-st-pauli",
  "fenerbahçe": "/collections/fenerbahce",
  "fiorentina": "/collections/fiorentina",
  "flamengo": "/collections/flamengo",
  "fluminense": "/collections/fluminense",
  "france": "/collections/franca",
  "fulham": "/collections/fulham",
  "galatasaray": "/collections/galatasaray",
  "germany": "/collections/germany",
  "getafe": "/collections/getafe",
  "ghana": "/collections/ghana",
  "grêmio": "/collections/gremio",
  "inter miami": "/collections/inter-miami",
  "inter milan": "/collections/inter-milan",
  "internacional": "/collections/internacional",
  "ireland": "/collections/ireland",
  "isaac": "/collections/isaac",
  "italy": "/collections/italy",
  "ivory coast": "/collections/ivory-coast",
  "jamaica": "/collections/jamaica",
  "japan": "/collections/japao",
  "juventus": "/collections/juventus",
  "kids collection": "/collections/kids-collection",
  "kids world cup 2026 ™": "/collections/kids-world-cup-2026-™",
  "kit kids": "/collections/kit-kids",
  "la liga": "/collections/la-liga",
  "lazio": "/collections/lazio",
  "leeds united": "/collections/leeds-united",
  "leicester city": "/collections/leicester-city",
  "liga mx": "/collections/liga-mx",
  "liga mx collection": "/collections/liga-mx-collection",
  "liga portugal": "/collections/liga-portugal",
  "ligue 1": "/collections/ligue-1",
  "liverpool": "/collections/liverpool",
  "long sleeve jerseys": "/collections/long-sleeve-jerseys-world-cup-2026-™-copia",
  "long sleeve jerseys world cup 2026 ™": "/collections/long-sleeve-jerseys-world-cup-2026-™",
  "luton town": "/collections/luton-town",
  "manchester city": "/collections/manchester-city",
  "manchester united": "/collections/manchester-united",
  "men’s international jerseys 2025/26": "/collections/men-s-international-jerseys-2025-26",
  "mexico": "/collections/mexico",
  "middlesbrough": "/collections/middlesbrough",
  "millwall": "/collections/millwall",
  "mls": "/collections/mls",
  "monaco": "/collections/monaco",
  "monarcas morelia (ahora mazatlán fc)": "/collections/monarcas-morelia-ahora-mazatlan-fc",
  "monterrey": "/collections/monterrey",
  "morocco": "/collections/morocco-1",
  "napoli": "/collections/napoli",
  "national team": "/collections/national-team",
  "national teams": "/collections/national-teams",
  "national teams collection": "/collections/national-teams-collection",
  "nba": "/collections/nba",
  "netherlands": "/collections/netherlands",
  "new season 2025/26": "/collections/new-season-2025-26",
  "newcastle": "/collections/newcastle",
  "newcastle united": "/collections/newcastle-united",
  "nigeria": "/collections/nigeria",
  "norway": "/collections/norway",
  "norwich": "/collections/norwich",
  "nottingham forest": "/collections/nottingham-forest",
  "olympiacos": "/collections/olympiacos",
  "olympique de marseille": "/collections/olympique-de-marseille-1",
  "olympique lyonnais": "/collections/kids-olympique-lyonnais",
  "other liga mx clubs": "/collections/other-liga-mx-clubs",
  "pachuca": "/collections/pachuca",
  "palmeiras": "/collections/palmeiras",
  "paris saint-germain": "/collections/paris-saint-germain",
  "peñarol": "/collections/penarol",
  "peru": "/collections/peru",
  "player jerseys world cup 2026 ™": "/collections/player-jersey-world-cup-2026-™",
  "portsmouth": "/collections/swansea-city",
  "portugal": "/collections/portugal-1",
  "premier league": "/collections/premier-league",
  "preston north end": "/collections/preston-north-end",
  "products 2024/25": "/collections/products-2025-26-copia",
  "products 2025/26": "/collections/products-2025-26",
  "pumas unam": "/collections/pumas-unam",
  "qpr": "/collections/qpr",
  "rangers": "/collections/rangers",
  "rb leipzig": "/collections/rb-leipzig",
  "real betis": "/collections/real-betis",
  "real madrid": "/collections/real-madrid",
  "real sociedad": "/collections/real-sociedad",
  "recently added": "/collections/recently-added",
  "retro version": "/collections/retro-version",
  "river plate": "/collections/river-plate",
  "santos": "/collections/santos",
  "santos laguna": "/collections/santos-laguna",
  "são paulo": "/collections/sao-paulo",
  "saudi arabia": "/collections/saudi-arabia",
  "saudi pro league": "/collections/saudi-pro-league",
  "saúl": "/collections/saul",
  "scotland": "/collections/scotland-1",
  "senegal": "/collections/senegal",
  "serie a": "/collections/serie-a",
  "serie a collection": "/collections/serie-a-collection",
  "sevilla": "/collections/sevilla",
  "sevilla fc": "/collections/sevilla-fc",
  "sheffield united": "/collections/sheffield-united-⚪",
  "sinisterra": "/collections/sinisterra",
  "south korea": "/collections/south-korea",
  "southampton": "/collections/southampton-1",
  "spain": "/collections/spain",
  "speedbricks": "/collections/speedbricks",
  "sporting": "/collections/sporting",
  "stoke city": "/collections/stoke-city",
  "sunderland": "/collections/sunderland",
  "sunderland hummel": "/collections/sunderland-hummel",
  "swansea city": "/collections/swansea-city-1",
  "sweden": "/collections/sweden-1",
  "talles magno": "/collections/talles-magno",
  "thiago maia": "/collections/thiago-maia",
  "tigres uanl": "/collections/tigres-uanl-1",
  "tijuana": "/collections/tijuana-🔴",
  "todos os produtos (sem patch, chaveiro)": "/collections/todos-os-produtos-sem-patch-chaveiro_",
  "todos produtos": "/collections/todos-produtos-1",
  "toluca": "/collections/toluca",
  "tottenham hotspur": "/collections/tottenham-hotspur-1",
  "training world cup 2026 ™": "/collections/training-world-cup-2026-™",
  "tunisia": "/collections/tunisia",
  "türkiye national team collection": "/collections/turkey-national-team-collection",
  "tv show jerseys": "/collections/tv-show-jerseys",
  "ukraine": "/collections/ukraine-1",
  "united states": "/collections/estados-unidos",
  "uruguay": "/collections/uruguay",
  "valencia": "/collections/valencia",
  "valencia cf": "/collections/valencia-cf",
  "vasco da gama": "/collections/vasco-da-gama",
  "venezia": "/collections/venezia",
  "villalba": "/collections/villalba",
  "villarreal": "/collections/villarreal",
  "vitão": "/collections/vitao",
  "vitor roque": "/collections/vitor-roque",
  "walace": "/collections/walace",
  "watford": "/collections/b",
  "west ham united": "/collections/west-ham-united",
  "winter collection": "/collections/winter-collection",
  "wolverhampton": "/collections/wolverhampton",
  "wolverhampton wanderers": "/collections/wolverhampton-wanderers",
  "women": "/collections/women",
  "world cup 2026 ™": "/collections/world-cup-2026-™",
  "worldwide collection": "/collections/worldwide-collection",
  "yuri alberto": "/collections/yuri-alberto",
  "man united": "/collections/manchester-united",
  "man utd": "/collections/manchester-united",
  "man city": "/collections/manchester-city",
  "mancity": "/collections/manchester-city",
  "milan": "/collections/ac-milan",
  "inter": "/collections/inter-milan",
  "sp": "/collections/sao-paulo",
  "paris saint germain": "/collections/paris-saint-germain",
  "bvb": "/collections/borussia-dortmund",
  "leverkusen": "/collections/bayer-leverkusen",
  "leipzig": "/collections/rb-leipzig",
  "atletico": "/collections/atletico-madrid",
  "psg": "/collections/paris-saint-germain",
  "usa": "/collections/estados-unidos",
  "eua": "/collections/estados-unidos",
  "espanha": "/collections/spain",
  "alemanha": "/collections/germany",
  "franca": "/collections/franca",
  "holanda": "/collections/netherlands",
  "japao": "/collections/japao",
  "coreia": "/collections/south-korea",
  "turkey": "/collections/turkey-national-team-collection",
  "turkiye": "/collections/turkey-national-team-collection",
  "champions league": "/collections/champions-league",
  "best sellers": "/collections/best-sellers-collection",
  "kids": "/collections/kit-kids",
  "feminino": "/collections/women",
  "retro": "/collections/retro",
  "legends": "/collections/legends-collection",
  "world cup": "/collections/world-cup-collection",
  "worldcup": "/collections/world-cup-collection",
  "home jersey": "/collections/26-27-collection",
  "new season": "/collections/26-27-collection",
  "26/27": "/collections/26-27-collection"
};

  function normalizeQuery(q) {
    return q.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function findCollection(query) {
    // 1. Exact match first
    if (COLLECTION_MAP[query]) return COLLECTION_MAP[query];
    
    // 2. Check all keys for best match
    var bestKey = null;
    var bestLen = 0;
    
    for (var key in COLLECTION_MAP) {
      if (COLLECTION_MAP.hasOwnProperty(key)) {
        if (query === key) {
          return COLLECTION_MAP[key];
        }
        if (query.indexOf(key) !== -1 && key.length > bestLen) {
          bestLen = key.length;
          bestKey = key;
        }
      }
    }
    
    if (bestKey) return COLLECTION_MAP[bestKey];
    return null;
  }

  function handleSearchRedirect(query) {
    if (!query || query.length < 2) return false;
    var q = normalizeQuery(query);
    var url = findCollection(q);
    if (url) {
      window.location.href = url;
      return true;
    }
    return false;
  }

  // Intercept all search form submissions (header search, mobile search bar, search page)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form) return;
    
    // Check if this is a search form
    var action = (form.getAttribute('action') || '').toLowerCase();
    var isSearch = action.indexOf('/search') !== -1 || action.indexOf('?q=') !== -1;
    
    if (!isSearch) return;
    
    var qInput = form.querySelector('input[name="q"]');
    if (!qInput) return;
    
    var query = qInput.value.trim();
    if (!query) return;
    
    if (handleSearchRedirect(query)) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Also intercept clicks on "SEARCH FOR" in predictive search
  document.addEventListener('click', function(e) {
    var target = e.target.closest('[data-predictive-search-search-for-text], .predictive-search__item-query-result, a[href*="/search?q="]');
    if (!target) return;
    
    // Get the search term from the link/button
    if (target.tagName === 'A') {
      var href = target.getAttribute('href') || '';
      var match = href.match(/[?&]q=([^&]+)/);
      if (match) {
        var q = decodeURIComponent(match[1].replace(/\+/g, ' '));
        if (handleSearchRedirect(q)) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  });

  // If we're already on the search results page, try to redirect
  if (window.location.pathname === '/search') {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (q && !params.get('sort_by')) {
      handleSearchRedirect(q);
    }
  }

})();
